import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
const LOGO = "/images/Logo.webp";
const AROMA = "/images/aroma.webp";

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/products/agarbatti', label: 'Agarbatti' },
  { to: '/products/dhoop-cone', label: 'Dhoop Cone' },
  { to: '/products/dhoop-stick', label: 'Dhoop Stick' },
  { to: '/products/other', label: 'Other Products' },

  { to: '/contact', label: 'Contact Us' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo(0, 0);
  }, [loc.pathname]);

  // Close menu on outside click
  useEffect(() => {
    if (!menuOpen) return;
    const handler = (e) => {
      if (!e.target.closest('.nav')) setMenuOpen(false);
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [menuOpen]);

  const isActive = (path) =>
    path === '/' ? loc.pathname === '/' : loc.pathname.startsWith(path);

  return (
    <header className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="nav__inner">

        {/* ── Logo: only image, no text ── */}
       <Link to="/" className="nav__logo" aria-label="Prakhyat Home">
  <div className="nav__logo-wrap">
    <img src={LOGO} alt="Prakhyat Logo" className="nav__logo-img main-logo" />
    
    <span className="nav__logo-divider"></span>
    
    <img src={AROMA} alt="Aroma Logo" className="nav__logo-img aroma-logo" />
  </div>
</Link>

        {/* ── Desktop Links ── */}
        <nav className="nav__links" aria-label="Main navigation">
          {NAV_LINKS.map(({ to, label }, i) => (
            <Link
              key={to}
              to={to}
              className={`nav__link ${isActive(to) ? 'nav__link--active' : ''}`}
              style={{ animationDelay: `${i * 0.07}s` }}
            >
              {label}
            </Link>
          ))}
        </nav>

        {/* ── CTA ── */}
        <a
          href="https://wa.me/919320905751"
          className="nav__cta"
          target="_blank"
          rel="noreferrer"
        >
          💬 Get Quote
        </a>

        {/* ── Hamburger ── */}
        <button
          className={`nav__hamburger ${menuOpen ? 'nav__hamburger--open' : ''}`}
          onClick={() => setMenuOpen((v) => !v)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* ── Mobile Menu ── */}
      <div
        className={`nav__mobile ${menuOpen ? 'nav__mobile--open' : ''}`}
        aria-hidden={!menuOpen}
      >
        {NAV_LINKS.map(({ to, label }, i) => (
          <Link
            key={to}
            to={to}
            className={`nav__mobile-link ${isActive(to) ? 'nav__mobile-link--active' : ''}`}
            style={{ transitionDelay: menuOpen ? `${i * 0.05}s` : '0s' }}
          >
            {label}
          </Link>
        ))}

        <a
          href="https://wa.me/919320905751"
          className="nav__mobile-cta"
          target="_blank"
          rel="noreferrer"
        >
          💬 WhatsApp Quote
        </a>
      </div>
    </header>
  );
}
